// extracted by mini-css-extract-plugin
export var boxItems = "_5f-1";
export var boxItemsLg = "_5f-2";
export var button = "_5f-7";
export var buttonLg = "_5f-8";
export var filterGroupBox = "_5f-0";
export var icon = "_5f-3";
export var iconSecondary = "_5f-6";
export var iconWrapper = "_5f-4";
export var iconWrapperLg = "_5f-5";